import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'bc-access-denied',
  template: `
    <img
      src="/assets/images/error-403.png"
      alt="Access Denied"
    />
    <div class="flex flex-column align-items-center gap-spacing-default">
      <h3 class="body-large-bold text-primary-color m-0">
        Error 403. Access Denied
      </h3>
      <p class="body-medium-regular text-caption-color m-0">
        Sorry, but you don't have permission to access this server.
      </p>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: var(--spacing-3xl, 24px);
      padding: var(--px-200, 200px) 0 var(--spacing-3xl, 24px) 0;
      background: #ffffff;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AccessDeniedComponent {}
